// src/app/app.routes.ts

import { Routes } from '@angular/router';
import { AuthenticationGuard } from './core/auth/authentication.guard'; 
import { EmployeeAuthenticationGuard } from './core/auth/employee-authentication.guard';
import { ResetpasswordComponent } from "./login/reset/resetpassword.component";
import { ForgotComponent } from './login/forgot/forgot.component';
import { NewpasswordComponent } from './login/newpassword/newpassword.component';
import { SsoWidjetComponent } from './sso-widjet/sso-widjet.component';

export const routes: Routes = [{ 
    path: 'login',
    loadChildren: () => import('./login/login.routes').then(m => m.routes)

},
{
    path: 'support/:token',
    component: SsoWidjetComponent
},
{
    path: 'freshworks',
    loadChildren: () => import(`./freshworks/freshworks.routes`).then((m) => m.routes), canActivate: [AuthenticationGuard]
},{
    path: '',
    loadChildren: () => import(`./all-modules/all-modules.routes`).then((m) => m.routes),
    canActivate: [AuthenticationGuard]
}, { path: 'reset/password', component: ResetpasswordComponent },
{ path: 'forgot/password', component: ForgotComponent },
{ path: 'new/password/:token', component: NewpasswordComponent },
{ path: '**', redirectTo: '/login' }];